import { combineReducers } from 'redux';

import sportCoachDashboardUiReducer from './sportCoachDashboardUiReducer';
import sportCoachDashboardDataReducer from './sportCoachDashboardDataReducer';

export default combineReducers({
  ui: sportCoachDashboardUiReducer,
  data: sportCoachDashboardDataReducer,
});
